import React, { useEffect } from 'react';
import styled from 'styled-components';

const BrickContainer = styled.div`
  margin-top: 24px;
  min-height: 200px;
`;

interface CardPaymentBrickProps {
  publicKey: string;
  amount: number;
  maxInstallments?: number;
  onSubmit: (formData: any, additionalData?: any) => Promise<void>;
  onReady: () => void;
  onError: (error: any) => void;
}

declare global {
  interface Window {
    MercadoPago: any;
    paymentBrickController: any;
  }
}

export const PaymentBrick: React.FC<CardPaymentBrickProps> = ({
  publicKey,
  amount,
  maxInstallments = 1,
  onSubmit,
  onReady,
  onError
}) => {
  useEffect(() => {
    if (!window.MercadoPago) {
      onError(new Error('MercadoPago SDK not loaded'));
      return;
    }

    const mp = new window.MercadoPago(publicKey, { locale: 'pt-BR' });
    const bricksBuilder = mp.bricks();

    const renderCardBrick = async () => {
      const settings = {
        initialization: {
          amount,
          payer: {},
        },
        customization: {
          visual: { style: { theme: 'default' } },
          paymentMethods: {
            maxInstallments,
          },
        },
        callbacks: {
          onReady: () => onReady(),
          onSubmit: (formData: any, additionalData: any) => onSubmit(formData, additionalData),
          onError: (error: any) => onError(error),
        },
      };

      try {
        window.paymentBrickController = await bricksBuilder.create(
          'cardPayment',
          'paymentBrick_container',
          settings
        );
      } catch (error) {
        onError(error);
      }
    };

    renderCardBrick();

    return () => {
      if (window.paymentBrickController) {
        window.paymentBrickController.unmount?.();
        window.paymentBrickController = null;
      }
    };
  }, [publicKey, amount, onReady, onSubmit, onError]);

  return <BrickContainer id="paymentBrick_container" />;
};
